module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git4-e30113b17711d1d67f671a011bc7b640.svg";